import { render, staticRenderFns } from "./UserGroupEditModal.vue?vue&type=template&id=8e943a5c"
import script from "./UserGroupEditModal.vue?vue&type=script&lang=ts"
export * from "./UserGroupEditModal.vue?vue&type=script&lang=ts"
import style0 from "./UserGroupEditModal.vue?vue&type=style&index=0&id=8e943a5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports